import useViewsSelector from "views/stores/useViewsSelector";
import { selectUndeclaredParameters } from "views/logic/slices/searchMetadataSelectors";
const useUndeclaredParameters = () => useViewsSelector(selectUndeclaredParameters);
export default useUndeclaredParameters;
